import type { ComponentProps } from 'react';

const LocationAvailable = (props: ComponentProps<'svg'>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_105_45915)">
      <g clipPath="url(#clip1_105_45915)">
        <path
          d="M19.103 6.23788C19.2753 5.81952 19.1769 5.33788 18.8569 5.01796C18.537 4.69804 18.0554 4.5996 17.637 4.77186L5.26201 9.83436C4.76279 10.0383 4.48154 10.5656 4.58349 11.093C4.68545 11.6203 5.14951 12 5.6874 12H11.8749V18.1875C11.8749 18.7254 12.2546 19.1859 12.7819 19.2914C13.3093 19.3969 13.8366 19.1121 14.0405 18.6129L19.103 6.23788Z"
          fill="#EE4F5E"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_105_45915">
        <rect width="24" height="24" fill="white" />
      </clipPath>
      <clipPath id="clip1_105_45915">
        <rect
          width="15.75"
          height="18"
          fill="white"
          transform="translate(4 3)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default LocationAvailable;
